import { Badge } from '@/shared/components/ui/badge';

interface SavingsBadgeProps {
  basePrice: number | null;
  price: number | null;
}

export function SavingsBadge(props: SavingsBadgeProps) {
  const basePrice = props.basePrice ?? 0;
  const price = props.price ?? 0;
  const savings = Math.round(((basePrice - price) / basePrice) * 100);
  if (savings > 0 && savings < 100) {
    return (
      <Badge className="bg-positive-500 font-extrabold text-white uppercase">
        Save {Math.round(savings)}%
      </Badge>
    );
  }
  // No savings
  return null;
}
